import ModalGenerateMatrix, {
  GenerateMatrixFunction,
} from '@/components/astro.ai/generate/ModalGenerateMatrix';
import MainButton from '@/components/ui/custom/buttons/MainButton';
import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import { useAbortController } from '@/data/hook/useAbortController';
import useSafePortal from '@/data/hook/useSafePortal';
import useToggle from '@/data/hook/useToggle';
import { lessonBlocksGenerator } from '@/data/services/astro.ai/generateServices';
import { TempLesson } from '@/models/Lesson';
import { TempLessonBlock } from '@/models/_deprecated/LessonBlock';
import { SparklesIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';
import { GenerateActionProps } from './GenerateActionProps';

export const GenerateBlocksAction = ({
  setValue,
  courseId,
  disabled,
  locked,
  hasValue,
}: GenerateActionProps) => {
  const createSafePortal = useSafePortal();
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseStudio.actions',
  });
  const { signal, abort } = useAbortController();
  const generate: GenerateMatrixFunction = async args => {
    if (!courseId) return;
    const { lessonBlocks } = await lessonBlocksGenerator(
      {
        coursePathId: courseId,
        ...args,
      },
      signal,
    );

    const tempBlocks = lessonBlocks.map(block => {
      return new TempLessonBlock({
        name: block.name,
        order: block.order,
        lessons: block.lessons.map(lesson => {
          return new TempLesson({
            name: lesson.lesson.title,
            order: lesson.lesson.order,
            description: lesson.lesson.description,
          });
        }),
      });
    });

    setValue('lessonBlocks', tempBlocks);
  };

  const { isOpen, close, open } = useToggle();

  const onCancel = () => {
    abort();
    close();
  };

  return (
    <Fragment>
      <ConditionalWrapper
        condition={!!locked}
        wrapper={<Tooltip text={t('generateMatrix.locked')} />}
      >
        <MainButton
          onClick={open}
          icon={<SparklesIcon className="w-4 h-4" />}
          text={t('generateMatrix.name')}
          disabled={disabled || locked || !courseId}
        />
      </ConditionalWrapper>
      {createSafePortal(
        <ModalGenerateMatrix
          visible={isOpen}
          onClose={onCancel}
          onGenerate={generate}
          hasValue={hasValue}
        />,
      )}
    </Fragment>
  );
};
